import type { Room } from "../../../interfaces/interfaces";

export default [
  {
    name: "A1",
    id: "b055ca05-8247-49ab-8f44-5ef956d6e928",
  },
  {
    name: "A2",
    id: "e16648a0-6d80-4d0e-b448-6554f306258b",
  },
  {
    name: "ACAS",
    id: "0597444e-4145-4f46-bac6-22b661d2d459",
  },
  {
    name: "A23",
    id: "f60028ff-5ee2-4850-8b72-037dba02c0cf",
  },
  {
    name: "A24",
    id: "e1777750-022e-4c7e-9c4d-eb6ae70ca8aa",
  },
  {
    name: "A25",
    id: "e1488830-f90a-4e9e-ab62-4d69ad854e9d",
  },
  {
    name: "A35",
    id: "5caccf48-7d4a-465f-8586-512bd15e9d44",
  },
  {
    name: "A36",
    id: "c29d82da-c58a-43e7-a15e-68ec994026cb",
  },
  {
    name: "A37",
    id: "d117aadd-07f5-46d7-aedf-f3843206d3a4",
  },
  {
    name: "A38",
    id: "7b55698c-a294-4d4f-9376-9a97bc160142",
  },
  {
    name: "A31",
    id: "c8b39a30-4459-411f-93fe-a8c826412a7a",
  },
  {
    name: "A32",
    id: "2b70e53a-a5cb-4bff-8c47-80c8544f0f75",
  },
  {
    name: "A33",
    id: "e69fb2a9-0e7f-48b0-83ba-5f3b8559736f",
  },
  {
    name: "A34",
    id: "5e1d5073-3b23-4422-83a0-70668c88ba11",
  },
  {
    name: "A303",
    id: "a60e2ddc-096d-4c66-95db-9e94d4ab3ecc",
  },
  {
    name: "A301",
    id: "0aef7b75-2b7f-47ec-9e88-92b8737b8436",
  },
  {
    name: "A302",
    id: "d2187be2-4a4f-4964-a0b2-5824d872a3fb",
  },
  {
    name: "A300",
    id: "f6a2aed4-04b3-48ba-8179-d6df819b6adc",
  },
  {
    name: "A310",
    id: "954f760c-52e6-449a-a2a9-2647f77e2847",
  },
  {
    name: "A311",
    id: "20d49e0b-7f02-4b15-8617-1a21771ecd28",
  },
  {
    name: "AG21",
    id: "30d1aa43-f74f-46d9-89df-cdabdc804056",
  },
  {
    name: "AG24",
    id: "fdd4dbd4-5a38-47fb-87b5-480d12cb934d",
  },
  {
    name: "AG22",
    id: "6ab199a7-22ae-4898-ba58-6a22331182c1",
  },
  {
    name: "AG23",
    id: "5f7b1f8c-cef6-4e93-bccb-c0ad1ca22276",
  },
  {
    name: "AG32",
    id: "5adcd93e-4d88-435d-8033-68c7165659e4",
  },
  {
    name: "AG35",
    id: "769660a4-59c4-4dbf-bf6d-0993c76f0427",
  },
  {
    name: "AG31",
    id: "71b377e7-c407-4e97-b458-4e4f0bb0ade8",
  },
  {
    name: "AG33",
    id: "90be0bb2-0b2b-4978-8ea7-c111e0c5a4bd",
  },
  {
    name: "AG34",
    id: "79412132-b4c5-426b-9855-6fa524444e6b",
  },
  {
    name: "AG26",
    id: "e7e6bfd8-88bd-42ee-bd60-90547587e2f1",
  },
  {
    name: "Ledsna Flickan",
    id: "ded3e52b-5526-4e17-9879-f04b1702e597",
  },
  {
    name: "Alfheim",
    id: "e8612043-8aca-4989-a04c-a7c49f5c8640",
  },
] as Room[];
